import { render, staticRenderFns } from "./AttachOrgObjectSplitButton.vue?vue&type=template&id=a46bee96&scoped=true"
import script from "./AttachOrgObjectSplitButton.vue?vue&type=script&setup=true&lang=js"
export * from "./AttachOrgObjectSplitButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AttachOrgObjectSplitButton.vue?vue&type=style&index=0&id=a46bee96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a46bee96",
  null
  
)

export default component.exports